import { Button, CircularProgress } from "@material-ui/core";
import * as React from "react";
import { Flipped, Flipper } from "react-flip-toolkit";
import { InView } from "react-intersection-observer";
import {
  useFeedContext,
  useFeedDispatchContext,
} from "./FeedFilter/State/FeedContext";
import { GroopitWithErrorBoundary } from "./Groopits/Groopit";
import { useGroupContext } from "groopit-js";
import { isDefaultFilter } from "./FeedFilter/GroopitFilterDTO";
import { useFilterContext } from "./FeedFilter/State/FilterContext";

export const GroopitFeed = (): JSX.Element => {
  const feed = useFeedContext();
  const { filter } = useFilterContext();
  const { loadMore, sortFeed } = useFeedDispatchContext();

  return (
    <>
      {feed.groopits && (
        <Flipper
          flipKey={`${feed.groopits.length},${
            feed.groopits.filter((p) => p.pinned).length
          }`}
        >
          {feed.groopits.map((g) => (
            <Flipped key={g.id} flipId={g.id}>
              <div>
                <GroopitWithErrorBoundary
                  groopit={g}
                  assignment={feed.assignments[g.assignmentId]}
                  on_pinChange={sortFeed}
                  is_popover={false}
                />
              </div>
            </Flipped>
          ))}
        </Flipper>
      )}
      {/* if we are loading more groopits, display the spinner
          * otherwise,
              if there are more groopits, display the load more button
              If there are no more groopits, display either
                the no more groopits message
                or the subscription limited message
        *
        */}
      {feed.loading ? (
        <div className="text-center mt-8 p-4">
          <CircularProgress />
        </div>
      ) : feed.totalCount > feed.groopits.length ? (
        <InView as="div" onChange={(inView) => inView && loadMore?.()}>
          <div className="text-center mt-8">
            <Button onClick={loadMore}>Load More</Button>
          </div>{" "}
        </InView>
      ) : feed.isLimitedBySubscription ? (
        <SubscriptionLimit />
      ) : feed.totalCount === 0 && !isDefaultFilter(filter) ? (
        <div className="my-8">
          No results found. Please update your filters and try again.
        </div>
      ) : (
        <div className="text-center my-8">No more Data</div>
      )}
    </>
  );
};

const SubscriptionLimit = () => {
  const { group, group_email, owner } = useGroupContext();
  return (
    <div className="my-8 mx-4">
      <span className="glyphicon glyphicon-exclamation-sign w-4 mt-1 mr-1 ml-2 text-red-600"></span>
      Upgrade the Groopit subscription to see more history. All members will be
      able to view data history once the subscription has been upgraded.
      {owner ? (
        <a href={`/Groop/Subscription/${group.id}`} className="text-red-600">
          View upgrade options.
        </a>
      ) : (
        <a href={`mailto:${group_email}`}>
          Contact the group organizer to request an upgrade.
        </a>
      )}
    </div>
  );
};
